export const SHOW_VOICE_ASSESSMENT_BETA_BADGE = true
